export { useCanonicalUrl } from './useCanonicalUrl'
